import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { LinkActionStatus } from '../types/LinkActionStatus';
import { getSharingUrls } from '../utils/getSharingUrls';
import { getSupportedPermissionLevels } from '../utils/getSupportedPermissionLevels';
import { getAttachmentPermissionLevelFromSharingLinkKind } from 'owa-attachment-permission';
import { userDate } from 'owa-datetime';
import { AnchorElementsSource } from 'owa-link-data';
import { ODCSharingInfo } from 'owa-sharing-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import { GetODCSharingInfoResponse } from 'owa-fileprovider-link-services';

export function createLinkModelForODC(
    linkId: string,
    url: string,
    response: GetODCSharingInfoResponse | null,
    source: AnchorElementsSource,
    unwrappedUrl: string
): SharingLinkInfo {
    let sharingInfo: ODCSharingInfo;
    const responseSucceeded: boolean =
        response && response.ResultCode === AttachmentResultCode.Success;
    sharingInfo = {
        getSharingInfoSucceeded: responseSucceeded,
        canShareInternally: responseSucceeded,
        canShareExternally: responseSucceeded,
        blocksDownload: false,
        expirationDate: response?.ExpirationDate ? userDate(response.ExpirationDate) : null,
        canRefresh: false, // VS 58779: to check whether recipient can refresh the expiring link and make sure refresh would work for ODC link.
        linkType: responseSucceeded ? response.Type : null,
        providerFileId: responseSucceeded ? response.providerFileId : null,
        location: responseSucceeded ? response.location : null,
    };

    return {
        linkId: linkId,
        providerType: AttachmentDataProviderType.OneDriveConsumer,
        fileName: response?.FileName,
        mimeType: response?.MimeType,
        url: url,
        unwrappedUrl: unwrappedUrl,
        accessTokenAvailable: false,
        permissionLevel: responseSucceeded
            ? getAttachmentPermissionLevelFromSharingLinkKind(
                  response.SharingLinkKind,
                  response.Type === 'edit',
                  false
              )
            : AttachmentPermissionLevel.None,
        sharingInfo: sharingInfo,
        supportedPermissionLevels: responseSucceeded
            ? getSupportedPermissionLevels(response, AttachmentDataProviderType.OneDriveConsumer)
            : null,
        sharingUrls: responseSucceeded ? getSharingUrls(response) : null,
        sharingTipsIgnored: [],
        sharingRecipientsInfo: { recipientPermissionInfos: [] },
        linkActionStatus: LinkActionStatus.none,
        source: source,
    };
}
